import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const citizenServicesCategoryField =`
id
serviceRequirementUniqueId
requirementIsMandatory
requirement {
  id
  requirementUniqueId
  requirementName
  requirementDescription
}
`;



export const GET_CITIZEN_SERVICES_REQUIREMENT = gql`
query CitizenGetServicesRequirements($serviceUniqueId:String){
    citizenGetServicesRequirements(serviceUniqueId:$serviceUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesCategoryField}
    }
  }
}
`
;
